// Text labels for lesson states, so status is never shown by colour alone (SPEC §9.2, §9.3).

import type { Lesson } from "../api/types";
import { t, translateCode } from "../i18n/i18n";

/** Labels such as "Substitute", "Cancelled", "Moved". */
export function describeLessonFlags(lesson: Lesson): string[] {
  const labels: string[] = [];
  addIf(labels, lesson.isCancelled, t("lessonFlags.cancelled"));
  addIf(labels, lesson.isCenterClosed, t("lessonFlags.centerClosed"));
  addIf(labels, lesson.isSubstituted, t("lessonFlags.substituted"));
  addIf(labels, lesson.isMoved, t("lessonFlags.moved"));
  addIf(labels, lesson.isRoomChanged, t("lessonFlags.roomChanged"));
  addIf(labels, lesson.dataProblems.length > 0, t("lessonFlags.problem"));
  return labels;
}

/** The CSS class for the lesson's main state (cancelled > closed > problem > substituted > moved). */
export function lessonStateClass(lesson: Lesson, hasProblem: boolean): string {
  if (lesson.isCancelled || lesson.isCenterClosed) {
    return "is-cancelled";
  }

  if (hasProblem || lesson.dataProblems.length > 0) {
    return "is-problem";
  }

  if (lesson.isSubstituted) {
    return "is-substituted";
  }

  return lesson.isMoved || lesson.isRoomChanged ? "is-moved" : "";
}

/** Translated data problems of a lesson. */
export function describeDataProblems(lesson: Lesson): string[] {
  return lesson.dataProblems.map((code: string): string => translateCode("dataProblems", code));
}

/** The app route of a lesson page. */
export function lessonRoute(lesson: { key: { groupId: string; date: string; slotId: string } }): string {
  return `/lessons/${lesson.key.groupId}/${lesson.key.date}/${lesson.key.slotId}`;
}

function addIf(labels: string[], condition: boolean, label: string): void {
  if (condition) {
    labels.push(label);
  }
}
